import { startOfDay } from 'date-fns';
import { getDateFromString } from 'utils/date';

export const checkIsCampaignStartDateLessThanToday = (campaignStartDate?: string | null): boolean => {
    const TODAY = startOfDay(new Date());
    const convertedCampaignStartDate = getDateFromString(campaignStartDate);

    return Boolean(convertedCampaignStartDate && convertedCampaignStartDate < TODAY);
};
